import { render } from "./eula.vue?vue&type=template&id=99696b12"
import script from "./eula.vue?vue&type=script&lang=js"
export * from "./eula.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__